import { render, staticRenderFns } from "./deptIndex.vue?vue&type=template&id=586f80f8&scoped=true"
import script from "./deptIndex.vue?vue&type=script&lang=js"
export * from "./deptIndex.vue?vue&type=script&lang=js"
import style0 from "./deptIndex.vue?vue&type=style&index=0&id=586f80f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586f80f8",
  null
  
)

export default component.exports